import { render, staticRenderFns } from "./InstallmentPayments.vue?vue&type=template&id=5cb7e665&"
import script from "./InstallmentPayments.vue?vue&type=script&lang=js&"
export * from "./InstallmentPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports